import PropTypes from 'prop-types';
import { etiColors, css } from '@eti/styles';
import { Icon } from '@eti/components';

const titleStyles = css`
  align-items: center;
  display: flex;
`;

const iconClassName = (shouldRotateIcon) => css`
  fill: ${etiColors.black};
  height: 15px;
  margin-right: 0.5rem;
  transform: ${shouldRotateIcon && 'rotate(180deg)'};
  width: 15px;

  html[dir='rtl'] & {
    margin-left: 0.5rem;
    margin-right: 0;
    transform: ${shouldRotateIcon ? 'rotate(0deg)' : 'rotate(180deg)'};
  }
`;

const BoundTitle = ({ text, shouldRotateIcon }) => (
  <strong className={titleStyles}>
    <Icon className={iconClassName(shouldRotateIcon)} id="plane" />
    <span>{text}</span>
  </strong>
);

BoundTitle.propTypes = {
  shouldRotateIcon: PropTypes.bool,
  text: PropTypes.string,
};

export default BoundTitle;
